import React, { useEffect, useState } from "react";
import MHeader from "components/MHeader";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import { Button } from "antd";
import AnswerCardDrawer from "./component/AnswerCardDrawer";
import {
    BaseQuestionType,
    PaperProps,
    QuestionnaireProps,
    TopicsItem
} from "../../../service";

import PageRadioDetail from "./component/PageRadioDetail";
import className from "classnames";
import PageCheckBoxDetail from "./component/PageCheckBoxDetail";
import PageSubjectiveDetail from "./component/PageSubjectiveDetail";

interface DetailMobileProps {
    data: PaperProps;
    headerData: QuestionnaireProps;
}

export default function QuestionnaireDetailMobile({
    data,
    headerData
}: DetailMobileProps) {
    const history = useHistory();
    const [showQuestionnaireBar, setShowQuestionnaireBar] = useState(false);
    const [checked, setChecked] = useState(1); //当前选中
    const [currentData, setCurrentData] = useState<TopicsItem>(); //选中的试题对象

    useEffect(() => {
        if (data) {
            setCurrentData(
                data.topics.find((item, index) => index + 1 === checked)
            );
        }
    }, [data, checked]);

    return (
        <div className={style.root}>
            <MHeader title="问卷详情" goBack={history.goBack} />

            <div className={style.header}>
                <Button
                    type="primary"
                    ghost
                    className={style.btnAnswerCard}
                    onClick={() => setShowQuestionnaireBar(true)}>
                    答题卡
                </Button>
            </div>
            {/*选项卡*/}
            <AnswerCardDrawer
                visible={showQuestionnaireBar}
                onClose={() => setShowQuestionnaireBar(false)}
                checked={checked}
                data={data.topics}
                onChange={(val: number) => setChecked(val)}
            />

            <div className={style.body}>
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.SingleChoice &&
                    checked === currentData.index && (
                        <PageRadioDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.MultipleChoice &&
                    checked === currentData.index && (
                        <PageCheckBoxDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.Subjective &&
                    checked === currentData.index && (
                        <PageSubjectiveDetail data={currentData} />
                    )}
            </div>

            <div className={style.footer}>
                <div className={style.postionRel}>
                    <div className={style.footerDiv}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={className(style.prev, {
                                    [style.one]: false
                                })}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={className(style.next, {
                                        [style.one]: false
                                    })}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
}
